import { render, staticRenderFns } from "./Stallion.vue?vue&type=template&id=f109e5fa&"
import script from "./Stallion.vue?vue&type=script&lang=js&"
export * from "./Stallion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports